<template>
	<card class="TaskendEdit"> 
		<ReFormPrinter 
			:masFormConfig="masAllFormParams" 
			:objSaveApiMethod="currentApiFormMethod"		
			:SuccessGo="SuccessGo"/>
	</card>
</template>
<script>
import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
export default {
	name: 'taskend_edit-page',
	components: {
		ReFormPrinter,
	},
	data() {
	    return {
			currentApiFormMethod: this.currentApiFormMethodSave(),
			masAllFormParams: this.currentFormConfig(),
		};
    },
	methods: {
		findElementById(elementGetParamMap){
			for (let i = 0; i < this.masAllFormParams[0].elements.length; i++) {
				if(this.masAllFormParams[0].elements[i].elementGetParamMap == elementGetParamMap) return this.masAllFormParams[0].elements[i];				
			}
		},
		currentApiFormMethodSave(){
			const taskend_id = typeof this.$route.params.te_id == 'undefined'?'':this.$route.params.te_id;
			return {apiMethod:'RUN_TASK',apiParam:{obj:'services' ,flt:{taskend_id:taskend_id,'client_id':this.$route.query.client_id,'id':this.$route.query.task_id,only_upd:true},uData:[]}};
		},
		currentFormConfig(){
			const taskend_id = typeof this.$route.params.te_id == 'undefined'?'':this.$route.params.te_id;
			this.$GVO.ApiCall('GET_FORM_TASKEND',{obj:'services',flt:{'taskend_id':taskend_id,'client_id':this.$route.query.client_id,'task_id':this.$route.query.task_id}})
				.then((objApi) => {
					if(objApi.success === true){
						// console.log(objApi);
						this.masAllFormParams = objApi.data.config;
						let ddmm = this.findElementById('ddmm');
						let district_ids = this.findElementById('district_ids');
						let metro_ids = this.findElementById('metro_ids');
						if(district_ids.element_model != '') ddmm.element_model.district_ids.value = district_ids.element_model;
						if(metro_ids.element_model != '') ddmm.element_model.metro_ids.value = metro_ids.element_model;
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		SuccessGo(){
			this.$router.go(-1);
		},

	},
	mounted() {

	}
};
</script>
<style scoped>
.TaskendEdit >>> .form-options-group > .row { flex-direction: row!important;}
.TaskendEdit >>> .list-row {display: flex; justify-content: space-between;} 
</style>
